import { createCustomerApp } from "./main";

let initialState = null;
if (window.__INITIAL_STATE__) {
  try {
    initialState = JSON.parse(window.__INITIAL_STATE__);
  } catch (error) {
    console.error(error);
  }
}

if (initialState?.popup) {
  try {
    initialState.popup.readIds = JSON.parse(localStorage.getItem('pinia/popup/readId') || '[]') || [];
  } catch (error) {
    console.error(error);
    initialState.popup.readIds = [];
  }
}

const { app, router } = createCustomerApp(initialState);

router.isReady().then(() => {
  //useLocalStorage 를 이용해 브라우저에 저장된 것을 가져와 덮어 씁니다.
  // pinia/popup/readId

  app.mount("#app");
  /*if(window.location.host !== 'candleworks.test') {
    Sentry.init({
      app,
      dsn: 'https://67ff4353dcad46658819a40de6bcfa62@o281406.ingest.sentry.io/1506692',
      integrations: [
        Sentry.browserTracingIntegration({router}),
        //Sentry.replayIntegration(),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // 번역:
      tracePropagationTargets: ["localhost", /^https:\/\/candleworks\.co\.kr\/api/, /^https:\/\/.*\.candleworks\.com\/api/],
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        //422 에러 무시
        'AxiosError',
        'undefined',
        'Request failed with status code 405',
        'Request failed with status code 422',
        'Network Error',
        'Request aborted',
        'Non-Error promise rejection captured with value: undefined',
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        /Unable to preload.*!/,
        'Importing a module script failed'
      ]
    });
  }*/
  // 전역 에러 핸들링 설정
  window.addEventListener('error', (event) => {
    let Storage = localStorage || window.localStorage || document.localStorage || null ;
    if(!Storage){
      return;
    }
    if( Storage.getItem('errorHandler') ) {
      Storage.removeItem('errorHandler');
      return;
    }
    // Importing a module script failed 에러는 새로고침 안내
    // Failed to fetch dynamically imported module 에러는 새로고침 안내
    const errros = ['Failed to fetch dynamically imported module', 'Importing a module script failed'];
    if (errros.includes(event.message)) {
      alert('업데이트된 내용이 있습니다. 새로고침 해주세요.');
      Storage.setItem('errorHandler', 'true');
    }
  })
});
